module.exports = __webpack_public_path__ + "static/media/agustin_giay.64a59392.jpg";